import { Shield } from 'lucide-react';

export function AdminUsers() {
  return (
    <div className="space-y-6">
      <div className="flex items-start gap-3">
        <div className="mt-1">
          <Shield className="w-6 h-6 text-primary-500" />
        </div>
        <div>
          <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-1">
            Admin User Management
          </h3>
          <p className="text-sm text-gray-600 dark:text-gray-400">
            For security, admin accounts are managed directly in Supabase rather than from the
            browser. Use the steps below to add or revoke admin access.
          </p>
        </div>
      </div>

      <div className="bg-gray-50 dark:bg-dark-700/50 rounded-lg p-4 space-y-3 text-sm text-gray-700 dark:text-gray-300">
        <h4 className="font-medium text-gray-900 dark:text-white">To add a new admin:</h4>
        <ol className="list-decimal list-inside space-y-1">
          <li>Open your Supabase project dashboard.</li>
          <li>Go to <span className="font-mono">Authentication → Users</span> and create or select a user.</li>
          <li>Copy the user&apos;s <span className="font-mono">id</span> and email.</li>
          <li>
            In the SQL editor, insert or update a row in <span className="font-mono">profiles</span>:
            <pre className="mt-2 bg-gray-900 text-gray-100 text-xs rounded-md p-3 overflow-x-auto">
{`insert into profiles (id, email, is_admin)
values ('<user-id>', '<user-email>', true)
on conflict (id) do update set is_admin = true;`}
            </pre>
          </li>
          <li>The user can now sign in and will see the admin panel as an administrator.</li>
        </ol>
      </div>

      <div className="bg-amber-50 dark:bg-amber-900/20 border border-amber-200 dark:border-amber-800 rounded-lg p-4 text-sm text-amber-800 dark:text-amber-200">
        <p className="font-medium mb-1">Why is this managed in Supabase?</p>
        <p>
          Granting admin rights requires a Supabase service role key, which must never be exposed in
          the browser. Managing admins through the Supabase dashboard and the <span className="font-mono">profiles</span>{' '}
          table keeps your production environment secure.
        </p>
      </div>
    </div>
  );
}
